<h1 class="title">Shared Resources</h1>
<h5>Manage subscription and licensing shared resources</h5>

<acabim-datatable
    #dataTable
    [dataSources]="dataSources"
    hasDetailView="true"
    stateStorage="session"
    stateKey="sharedResources-session"
></acabim-datatable>
